/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import { noopDetector } from '../../NoopDetector';

export const hostDetector = noopDetector;



// WEBPACK FOOTER //
// ../../../../../src/detectors/platform/browser/HostDetector.ts